import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  switch(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)

    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("is-active", i === index)
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("is-active", i === index)
    })
  }
}
